import { mercatorRelative, BBOxRelativeToCenter, transformCoordinates } from "../../services/MercatorRelativeToCenter";
import { useMapStore } from "../../store/useMapStore";
import { useBoundingBoxStoreRelative } from "../../store/useBoundingBoxStore";

export class LOD2BuildingEntity {
    constructor(building = {}) {
        this.data = building;
        this.area = building.area + ' m²'|| null;
        this.measuredheight = building.measuredHeight || null;
        this.buildingFunction = building.function || "";
        
        this.muncipalityName = building.municipalityName || null;
        this.objectId = building.objectId || '';
        this.objectType = building.objectType || '';
        this.roofShape = building.roofShape || "";
        this.volume = building.volume +  ' m³'|| "";
        // this.surfaces =  LOD2BuildingEntity.checkBuildingBBox(building.surfaces, useBoundingBoxStoreRelative.getState().boundingBox)//building.surfaces;//transformCoordinates(building.surfaces, useMapStore.getState().center);
        if(building.municipalityName == "Bremen" || building.municipalityName == "Bremerhaven" )
        {
            this.lod = 1;
            this.surfaces = LOD2BuildingEntity.GetGroundSurface(building.surfaces);
        }
        else{
            this.lod = building.lod || null;
            this.surfaces = building.surfaces;//transformCoordinates(building.surfaces, useMapStore.getState().center);

        }
        
        this.Name = "LOD2BuildingEntity";
        this.gebaeude = "";
        this.projectedsurfaces = LOD2BuildingEntity.projectBuildings(
                                    this.surfaces
                                );
    }

    static GetGroundSurface(surfaces)
    {
        let groundSurface = [];
        surfaces.forEach((surface)=>
        {
            if(surface.objectType == "GroundSurface")
            {
                groundSurface.push(surface);
            }
        })
        return groundSurface;
    }

    static checkBuildingBBox(surfaces, bbox)
    {
        let cleanSurfaces = [];
       // console.log("relative center: ", bbox)
        surfaces.forEach(surface => {
          if(LOD2BuildingEntity.isSurfaceInsideMain(surface.geometry.bbox,bbox))
          {
            cleanSurfaces.push(surface);
          }
        });
        return cleanSurfaces;
    }

    static isSurfaceInsideMain(surfaceBBox, mainBBox) {
    const [sMinX, sMinY, sMaxX, sMaxY] = surfaceBBox

    // Normalize main bbox in case min/max are flipped
    const mMinX = Math.min(mainBBox.minX, mainBBox.maxX)
    const mMaxX = Math.max(mainBBox.minX, mainBBox.maxX)
    const mMinY = Math.min(mainBBox.minY, mainBBox.maxY)
    const mMaxY = Math.max(mainBBox.minY, mainBBox.maxY)

    return (
            sMinX >= mMinX &&
            sMaxX <= mMaxX &&
            sMinY >= mMinY &&
            sMaxY <= mMaxY
        )
    }


    static projectBuildings(surfaces) {
        const projectedSurfaces = structuredClone(surfaces);

        const groundSurfaces = projectedSurfaces.filter(
            s => s.objectType === "GroundSurface"
        );

        let baseHeight;

        if (groundSurfaces.length) {
            const heights = LOD2BuildingEntity.collectGroundHeights(groundSurfaces);
            baseHeight = LOD2BuildingEntity.findDominantHeight(heights);
        } else {
            // fallback (rare but necessary)
            baseHeight = Math.min(
                ...projectedSurfaces.flatMap(s =>
                    s.geometry.coordinates.flat().map(v => v[2])
                )
            );
        }

        // Normalize ALL surfaces
        projectedSurfaces.forEach(surface => {
            surface.geometry.coordinates.forEach(polygon => {
                polygon.forEach(vertex => {
                    vertex[2] -= baseHeight;
                });
            });
        });

        return projectedSurfaces;
    }

    static collectGroundHeights(groundSurfaces) {
    const heights = [];

    groundSurfaces.forEach(surface => {
        surface.geometry.coordinates.forEach(polygon => {
            polygon.forEach(v => {
                heights.push(v[2]);
            });
        });
    });

    return heights;
}
static findDominantHeight(values, tolerance = 0.2) {
    const buckets = [];

    values.forEach(h => {
        let bucket = buckets.find(b => Math.abs(b.value - h) < tolerance);
        if (bucket) {
            bucket.count++;
        } else {
            buckets.push({ value: h, count: 1 });
        }
    });

    // Pick the most frequent height band
    return buckets.sort((a, b) => b.count - a.count)[0].value;
}

    static transformCoordinates(surfaces, mapCenter) {
    if (!Array.isArray(surfaces) || !mapCenter) return surfaces;

        return surfaces.map(surface => ({
            ...surface,
            geometry: {
            ...surface.geometry,
            coordinates: surface.geometry.coordinates.map(polygon =>
                polygon.map(ring =>
                BBOxRelativeToCenter(ring, mapCenter)
                    .map(p => [p.x, p.y, p.z])
                )
            )
            }
        }));
    }

    static fromResponse(response,bbox) {
       // console.log(response)
    if (response.data && response && response.data.buildingByBounds.buildings) {
        return response.data.buildingByBounds.buildings.map(
        entityData => new LOD2BuildingEntity(entityData)
            );
        }
    }
}
